import { Activity } from "lucide-react";
import { useMemo, useState } from "react";
import styled from "styled-components";
import { getAggregateState, LIVENESS_COLORS } from "src/services/livenessAggregated";
import { LivenessPopup } from "./LivenessPopup";
import { useLiveness } from "./useLiveness";
import { useTranslation } from "react-i18next";

export function LivenessStatus() {
	const { t } = useTranslation();
	const status = useLiveness();
	const [open, setOpen] = useState(false);
	const state = useMemo(() => status.error ? "unknown" : getAggregateState(status.records), [status.error, status.records]);
	const summary = status.error ? t("liveness.unavailable") : !status.updatedAt ? t("liveness.checking")
		: ["failed", "missed", "degraded"].includes(state) ? t("liveness.issues") : state === "success" ? t("liveness.operational") : t("liveness.partialData");
	return <>
		<Trigger type="button" aria-label={`${t("liveness.title")}: ${summary}`} title={`${t("liveness.title")}: ${summary}`}
			aria-expanded={open} aria-haspopup="dialog" onClick={() => setOpen(true)}>
			<Activity size={17} aria-hidden="true" /><TriggerLabel>{t("liveness.title")}</TriggerLabel>
			<Dot style={{ background: LIVENESS_COLORS[state] }} />
		</Trigger>
		{open && <LivenessPopup {...status} onClose={() => setOpen(false)} />}
	</>;
}

const Trigger = styled.button`
	display: flex; flex-shrink: 0; align-items: center; gap: 8px; min-height: 34px; padding: 7px 10px; margin: 0 8px;
	border: 1px solid hsl(30 10% 87%); border-radius: 7px; background: transparent; color: inherit; font: inherit; font-size: 13px; cursor: pointer;
	&:hover { background: hsl(40 10% 91%); }
	&:focus-visible { outline: 2px solid #a6421c; outline-offset: 2px; }
`;
const TriggerLabel = styled.span`@media (max-width: 1024px) { display: none; }`;
const Dot = styled.span`width: 7px; height: 7px; flex-shrink: 0; border-radius: 50%;`;
